import {
    buildSchema,
} from "@camberi/firecms";

const packageSchema = buildSchema({
    name: "Packages",
    properties: {
        title: {
            dataType: "string",
            title: "Title",
            validation: {
                required: true,
                requiredMessage: "Package name is required.",
            }
        },
        description: {
            dataType: "string",
            title: "Description",
            description: "Description is no longer displayed in package purchase page. Go to setting's ZenPro benifits to add desciption of ZenPro packages.",
            validation: {
                required: true,
            },
            config: {
                multiline: true,
            }
        },

        order: {
            dataType: "number",
            title: "Order",
            validation: {
                required: true,
            },
        },
        currency: {
            dataType: "string",
            title: "currency",
            validation: {
                required: true,
            },
        },


    }
});

packageSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default packageSchema;